<script>
  import { user } from "./refs/store.js";
  import { login } from "./refs/auth.js";
</script>

{#if !$user}
  <section>
    <button on:click={login} class="button">Signin with Google</button>
  </section>
{/if}
